/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Text_Content_Exceeds_HintInputs */



/**
* | output |
* | --- |
* | "Reduce the number of characters per line or reduce the number of lines in the Event." |
*
* @param {Error_Nav_Text_Content_Exceeds_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_text_content_exceeds_hint = /** @type {((inputs?: Error_Nav_Text_Content_Exceeds_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Text_Content_Exceeds_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reduisez le nombre de caracteres par ligne ou le nombre de lignes de l'evenement.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verringern Sie die Anzahl der Zeichen pro Zeile oder die Anzahl der Zeilen im Ereignis.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ridurre il numero di caratteri per riga o ridurre il numero di righe nell'evento.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Уменьшите количество символов в строке или уменьшите количество строк в событии.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reducir el número de caracteres por línea o reducir el número de líneas en el evento.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("减少每行字符数或减少事件中的行数。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1 行あたりの文字数を減らすか、イベント内の行数を減らします。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रति पंक्ति वर्णों की संख्या कम करें या इवेंट में पंक्तियों की संख्या कम करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reduza o número de caracteres por linha ou reduza o número de linhas no evento.")
	return /** @type {LocalizedString} */ ("Reduce the number of characters per line or reduce the number of lines in the Event.")
});